import { useEffect, useState } from "react";
import axios from "axios";
import { getUrl } from "../../requests";

export const useAppInitialization = () => {


    const [apikey, setApiKey] = useState(null);
    const [auth0ClientId, setAuth0ClientId] = useState(null);
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);
    const [cityName, setCityName] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {


        const fetchConfig = async () => {
            try {
                const res = await axios.get(`${getUrl()}/api/v1/system/frontendConfig`);
                const data = res.data;

                setApiKey(data.googleMapsKey);
                setAuth0ClientId(data.auth0ClientId);

                localStorage.setItem("ApiKey", data.googleMapsKey);
                localStorage.setItem("auth0ClientId", data.auth0ClientId);
                getLocation();
            } catch (err) {
                console.error("Błąd pobierania konfiguracji:", err);
            }
        };

        const fetchCityFromCoords = async (latVal, lngVal) => {
            try {
                const res = await axios.get(
                    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latVal}&longitude=${lngVal}&localityLanguage=pl`
                );
                const city = res.data.city || res.data.locality || res.data.principalSubdivision;
                setCityName(city);
                localStorage.setItem("city", city);
                localStorage.setItem("geolocation", "true");
            } catch (err) {
                console.error("Błąd reverse geocodingu:", err);
            }
        };

        const getLocation = () => {

            if (!navigator.geolocation) {
                console.error("Geolokalizacja niedostępna w tej przeglądarce");
                return;
            }
            navigator.geolocation.getCurrentPosition(
                async (position) => {

                    const latVal = position.coords.latitude.toFixed(4);
                    const lngVal = position.coords.longitude.toFixed(4);

                    setLat(latVal);
                    setLng(lngVal);

                    localStorage.setItem("lat", latVal);
                    localStorage.setItem("lng", lngVal);

                    await fetchCityFromCoords(latVal, lngVal);

                },
                (error) => {
                    console.error("Błąd geolokalizacji:", error);
                    localStorage.setItem("geolocation", "false");
                },
                {
                    timeout: 5000,
                    maximumAge: 0,
                    enableHighAccuracy: true,
                }
            );
        };

        const init = async () => {
            localStorage.clear();
            await fetchConfig();

            setIsReady(true);
        };

        init();
    }, []);

    return {
        apikey,
        auth0ClientId,
        lat,
        lng,
        cityName,
        isReady,
    };
};
